import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';


// 同步南北_产品分类/产品
export async function saveSNProductCategory(params) {
    return post(oaserver+'/api/snmasterData/sn/saveSNProductCategory', params, true)
}
// 同步南北_规格
export async function saveSNProductSpecification(params) {
    return post(oaserver+'/api/snmasterData/sn/saveSNProductSpecification', params, true)
}
// 同步用友_规格/产品分类/无产品
export async function saveYYProductSpecification(params) {
    return post(oaserver+'/api/masterData/yy/saveYYProductSpecification', params, true)
}

//产品树
export async function productTree(params) {
    return post(erpserver+'/product/productTree', params, true)
}
//产品分类新增
export async function addOrupdateProductCategory(params) {
    return post(erpserver+'/masterData/addOrUpdateProductCategory', params, true)
}
//部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true)
}
//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//产品分类属性
export async function findClassificationAttributes(params) {
    return post(erpserver+'/masterData/findClassificationAttributes', params, true)
}
//产品新增
export async function addOrupdateProduct(params) {
    return post(erpserver+'/masterData/addOrUpdateProduct', params, true)
}
//规格新增
export async function addOrupdateProductSpecification(params) {
    return post(erpserver+'/masterData/addOrUpdateProductSpecification', params, true)
}
//规格列表
export async function getProductSpecification(params) {
    return post(erpserver+'/masterData/getProductSpecifications', params, true)
}
export async function getUnitGroupList(params) {
    return post(oaserver+'/dict/unitGroup/getUnitGroupList', params, true);
}
///单位接口
export async function getDictList(param) {
    return post(oaserver+'/oacurrency/getDictList',param,true)
}
//产品-列表
export async function getPztypeContents(param) {
    return post(erpserver+'/masterData/getPztypeContents',param,true)
}
//产品分类详情
export async function getProductTypeDetail(param) {
    return post(erpserver+'/masterData/getProductTypeDetail',param,true)
}
//产品详情
export async function getProductDetail(param) {
    return post(erpserver+'/masterData/getProductDetail',param,true)
}
//转移产品分类
export async function productTypeSwitch(param) {
    return post(erpserver+'/masterData/productTypeSwitch',param,true)
}
//转移产品
export async function editPzTypeContent(param) {
    return post(erpserver+'/masterData/editPzTypeContent',param,true)
}
//产品-产品末级
export async function getLastProductType(param) {
    return post(erpserver+'/masterData/getLastProductType',param,true)
}

//已在产品-产品末级
export async function getProductRelated(param) {
    return post(erpserver+'/masterData/getProductRelated',param,true)
}


//转移产品规格
export async function productSpecifySwitch(param) {
    return post(erpserver+'/masterData/productSpecifySwitch',param,true)
}
//批量删除
export async function disablePzTypeContent(param) {
    return post(erpserver+'/masterData/disablePzTypeContent',param,true)
}
// 板块

export async function getSectorList(param) {
    return post(oaserver+'/dict/sector/getSectorList',param,true)
}

//规格下发列表
export async function getSpecificationDistributeList(params) {
    return post(erpserver+'/masterData/getSpecificationDistributeList', params, true)
}